import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { ModalController, ToastController } from '@ionic/angular';

@Component({
  selector: 'approve-case',
  templateUrl: './poldocument-approve-case.component.html'
})
export class PolDocumentApproveComponent implements OnInit {
  approveForm: FormGroup = new FormGroup({});
  pan: string;
  applicantName: string;

  constructor(private modalCtrl: ModalController, private toastController: ToastController) { }

  ngOnInit(): void { 
    this.approveForm = new FormGroup({
      outwardNo: new FormControl(null, [Validators.required, Validators.minLength(1), Validators.maxLength(100)])
    });  
  }


  async showErrorToast(errorMessage: string) {
    const toast = await this.toastController.create({
      message: errorMessage,
      icon: "information-circle",
      position: "top",
      duration: 2000,
    });
    toast.present();
  }
  approve() {
     console.log(this.approveForm.valid)
     console.log(this.approveForm.value.outwardNo)
    
     return this.modalCtrl.dismiss(this.approveForm.value.outwardNo, 'approve');
 
 }

 cancel() {
  console.log("Cancel Button Hit")
   return this.modalCtrl.dismiss(null, 'cancel');
 }

 public space(event:any){

   if (event.target.selectionStart === 0 && event.code === 'Space'){
     event.preventDefault();
   }
   }

}
